import React from "react";
import styled from "styled-components";
import Card from "../components/Card";
import FlexRow from "../components/FlexRow";

const CenterContent = styled.div`
  margin-top: 1.5rem;

  text-align: center;

  h3 {
    margin: 0;
  }

  p {
    font-size: 1.3rem;
  }
`;

const ContactInfo = styled.div`
  flex: 1;
`;

const RsvpPage = () => (
  <div>
    <Card header="RSVP">
      <CenterContent>
        <p>Please RSVP by Sunday, July 15, 2018</p>
        <p>
          Call, text, or email to RSVP and include if you will also be attending
          the rehearsal dinner and/or the Sunday brunch.
        </p>
        <p>
          Don't forget to visit <a href="/whats-happening">What's Happening</a>{" "}
          for event schedule, locations, and group rate hotel accommodations.
        </p>
        <p>We look forward to celebrating with our family and friends!</p>
        <FlexRow>
          <ContactInfo>
            <h3>Adam</h3>
            <p>
              <a href="tel:+1-720-289-4505">(720) 289-4505</a>
              <br />
              <a href="mailto:adam625@gmail.com">adam625@gmail.com</a>
            </p>
          </ContactInfo>
          <ContactInfo>
            <h3>Casey</h3>
            <p>
              <a href="tel:+1-812-589-9168">(812) 589-9168</a>
              <br />
              <a href="mailto:casey.t.lee@gmail.com">casey.t.lee@gmail.com</a>
            </p>
          </ContactInfo>
        </FlexRow>
      </CenterContent>
    </Card>
  </div>
);

export default RsvpPage;



// WEBPACK FOOTER //
// ./src/pages/rsvp.js